import { useMutation, useQueryClient } from '@tanstack/react-query';
import { PlannedSurvey } from '../../api/queries';
import { GetScheduledSurveysCacheKey } from '../queries/useGetPlannedSurveys';
import axios from 'axios';
import { GetPlannedSurveyByIDKey } from '../queries/useGetPlannedSurveyByID';

const updatePlannedSurvey = async (
  teamId: number,
  surveyId: number,
  survey: PlannedSurvey,
) => {
  return axios.put(`/api/schedule-surveys/${teamId}/${surveyId}`, {
    title: survey.title,
    description: survey.description,
    templateId: survey.templateId,
    scheduledTime: survey.scheduledTime,
    frequency: survey.frequency,
    isActive: survey.isActive,
    deadlineInDays: survey.deadlineInDays,
  });
};

export const key = 'UPDATE_PLANNED_SURVEY';

export const useUpdatePlannedSurveyMutation = (teamId: number) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      teamId,
      surveyId,
      survey,
    }: {
      teamId: number;
      surveyId: number;
      survey: PlannedSurvey;
    }) => updatePlannedSurvey(teamId, surveyId, survey),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [GetScheduledSurveysCacheKey.ScheduledSurveys, teamId],
      });
      queryClient.invalidateQueries({
        queryKey: [GetPlannedSurveyByIDKey, teamId],
      });
    },
  });
};
